import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { useTranslation } from "react-i18next";

import "swiper/css";
import "swiper/css/pagination";

const FOTO = "/fotoYeni.webp";

const DATA = [
  { nameKey: "before_after.mahmut.name", graftsKey: "before_after.mahmut.grafts", daysKey: "before_after.mahmut.days", main: FOTO, before: "/diş1Before.png", after: "/diş1After.png" },
  { nameKey: "before_after.jeremie.name", graftsKey: "before_after.jeremie.grafts", daysKey: "before_after.jeremie.days", main: FOTO, before: "/diş2Before.png", after: "/diş2After.png" },
];

export default function BeforeAfterSlider() {
  const swiperRef = useRef(null);
  const { t } = useTranslation();

  const dir = document?.documentElement?.dir || "ltr";
  const isRTL = dir === "rtl";

  const [showArrows, setShowArrows] = useState(false);

  useEffect(() => {
    const checkArrows = () => {
      const isDesktop = window.innerWidth >= 1024;
      if (isDesktop && DATA.length > 2) {
        setShowArrows(true);
      } else if (!isDesktop && DATA.length > 1) {
        setShowArrows(true);
      } else {
        setShowArrows(false);
      }
    };
    checkArrows();
    window.addEventListener("resize", checkArrows);
    return () => window.removeEventListener("resize", checkArrows);
  }, []);

  return (
    <section className="bg-[#0b1224] pb-8">
      <div className="relative max-w-5xl mx-auto px-4" id="oncesi">
        
        {/* Özel oklar */}
        {showArrows && (
          <div className="pointer-events-none absolute inset-y-0 -left-2 right-0 z-20 hidden md:block">
            <div className="relative h-full">
              <button
                onClick={() => swiperRef.current?.slidePrev()}
                aria-label={t("ba_prev")}
                className="pointer-events-auto absolute left-0 top-[38%] -translate-y-1/2 inline-flex items-center justify-center size-11 rounded-full bg-white/5 ring-2 ring-blue-400/70 hover:bg-white/10 transition"
              >
                <svg viewBox="0 0 24 24" className="size-6 text-blue-400">
                  <path fill="currentColor" d={isRTL ? "M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z" : "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"} />
                </svg>
              </button>
              <button
                onClick={() => swiperRef.current?.slideNext()}
                aria-label={t("ba_next")}
                className="pointer-events-auto absolute right-0 top-[38%] -translate-y-1/2 inline-flex items-center justify-center size-11 rounded-full bg-white/5 ring-2 ring-blue-400/70 hover:bg-white/10 transition"
              >
                <svg viewBox="0 0 24 24" className="size-6 text-blue-400">
                  <path fill="currentColor" d={isRTL ? "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" : "M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z"} />
                </svg>
              </button>
            </div>
          </div>
        )}

        <Swiper
          modules={[Pagination]}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          pagination={{ clickable: true }}
          spaceBetween={36}
          breakpoints={{ 0: { slidesPerView: 1 }, 1024: { slidesPerView: 2 } }}
          className="pb-12"
          dir={dir}
        >
          {DATA.map((item, idx) => (
            <SwiperSlide key={idx}>
              <article className="bg-[#10182b] rounded-[28px] px-5 pt-5 pb-8 md:px-6 md:pt-6 md:pb-10 shadow-[0_10px_40px_rgba(0,0,0,0.35)] h-full">
                <div className="relative">
                  {/* ANA FOTOĞRAF */}
                  <div className="mx-auto w-[82%] md:w-[86%] h-[360px] md:h-[420px] overflow-hidden rounded-3xl">
                    <img src={item.main} alt={`${item.nameKey} main`} className="w-full h-full object-cover" loading="lazy" />
                  </div>

                  {/* KÜÇÜK FOTOĞRAFLAR */}
                  <div className="flex items-start justify-center gap-3 md:gap-5 w-full absolute left-1/2 -translate-x-1/2 bottom-0 translate-y-1/2">
                    {/* BEFORE */}
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-[170px] h-[170px] md:w-[190px] md:h-[190px] rounded-2xl overflow-hidden bg-white shadow-[0_10px_30px_rgba(0,0,0,0.25)]">
                        <img src={item.before} alt={`${item.nameKey} before`} className="w-full h-full object-cover" loading="lazy" />
                      </div>
                      <span className="uppercase text-[12px] tracking-widest text-white/70">{t("ba_before")}</span>
                    </div>

                    {/* Çift ok */}
                    <div className="hidden md:flex items-center justify-center mt-[70px]">
                      <svg width="28" height="28" viewBox="0 0 24 24" className="text-white/80">
                        <path
                          fill="currentColor"
                          d={isRTL
                            ? "M16.59 8.59 15.17 7.17 20 12l-4.83 4.83 1.42 1.41L22.83 12 16.59 8.59zm-9.18 0L1.17 12l6.24 6.24 1.42-1.41L3.17 12l2.9-2.83-1.42-1.41z"
                            : "M7.41 8.59 8.83 7.17 4 12l4.83 4.83-1.42 1.41L1.17 12 7.41 8.59zm9.18 0L22.83 12l-6.24 6.24-1.42-1.41L20.83 12l-2.9-2.83 1.42-1.41z"}
                        />
                      </svg>
                    </div>

                    {/* AFTER */}
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-[170px] h-[170px] md:w-[190px] md:h-[190px] rounded-2xl overflow-hidden bg-white shadow-[0_10px_30px_rgba(0,0,0,0.25)]">
                        <img src={item.after} alt={`${item.nameKey} after`} className="w-full h-full object-cover" loading="lazy" />
                      </div>
                      <span className="uppercase text-[12px] tracking-widest text-white/70">{t("ba_after")}</span>
                    </div>
                  </div>
                </div>

                {/* Bilgi kartı */}
                <div className="mt-[120px] md:mt-[140px] w-[260px] max-w-full mx-auto bg-white text-slate-900 rounded-2xl shadow-[0_8px_24px_rgba(0,0,0,0.25)] px-6 py-4 text-center">
                  <div className="text-[12px] tracking-wide text-slate-500">{t(item.nameKey)}</div>
                  <div className="text-[15px] font-semibold leading-tight">{t(item.graftsKey)}</div>
                  <div className="text-[12px] font-medium text-slate-500">{t(item.daysKey)}</div>
                </div>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Pagination stil */}
        <style>{`
          .swiper-pagination { bottom: 0 !important; }
          .swiper-pagination-bullet { background: rgba(255,255,255,.5); opacity: 1; }
          .swiper-pagination-bullet-active { background: #fff; transform: scale(1.08); }
        `}</style>
      </div>
    </section>
  );
}
